
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { INotification } from '../store/modules/notifications'

const TIMEOUT = 6000

@Component({
  template: `
    <transition name="from-top" >
        <div class="notification-container flex flex-justify-center" v-if="visible" :class='{"center": center}'>
            <div class="notification-snackbar flex white">
            {{ message }}

            <div class="flex mt" v-if='continueShopping && goToCart'>
              <a @click="visible = false" class="button accent notification-snackbar__button">{{ continueShopping }}</a>
              <a :href='shoppingCartUrl' class="button ml notification-snackbar__button">{{ goToCart }}</a>
            </div>
            <button class="ml-025 notification-container__close-button" @click="visible = false">
              <i class="icons8-delete"></i>
            </button>
            </div>
        </div>
    </transition>
  `
})
export default class Notifications extends Vue {
  @Prop() shoppingCartUrl: string

  visible = false
  message: string | null = null
  center = false
  continueShopping: string | null = null
  goToCart: string | null = null

  @Watch('$store.state.notifications.all')
  onNotificationsChange(notifications: INotification[]) {
    const notification = notifications[0]
    if (notification) {
      const showSnackbar = () => {
        this.message = notification.message
        this.center = notification.center

        this.continueShopping = notification.continueShopping
        this.goToCart = notification.goToCart

        this.visible = true
        setTimeout(() => this.visible = false, notification.timeout || TIMEOUT)

        this.$store.commit('notifications/removeByIndex', 0)
      }

      if (this.visible) {
        setTimeout(() => {
          this.visible = false
          setTimeout(() => showSnackbar(), 400)
        }, 1500)
      } else {
        showSnackbar()
      }
    }
  }
}
